'use strict';
const wordWrap = require('./word-wrap'),
	fontMetrics = require('./font-metrics'),
	calcLineWidth = function (wrappedText) {
		let lineWidth = 0;
		wrappedText.forEach((line) => {
			if (line.width > lineWidth) {
				lineWidth = line.width;
			}
		});
		return lineWidth;
	};

module.exports = function createTextSizer(widthFunction, LineBreaker) {
	const sizer = function textSizer(title, maxWidth, fontInfo) {
		const font = fontMetrics(fontInfo),
			txWidth = function (text) {
				const width =  widthFunction(text, font);
				return Math.ceil(width * font.fontSize);
			},
			wrappedText = wordWrap(title, maxWidth, txWidth, LineBreaker),
			lineWidth = calcLineWidth(wrappedText),
			baseText = title.split('\n'),
			minWidth = wrappedText.length !== baseText.length ? maxWidth : lineWidth,
			ret =  {
				width: Math.ceil(Math.max(minWidth, lineWidth)),
				height: Math.max(Math.ceil(font.fontSize * 1.5), Math.ceil(wrappedText.length * (font.fontSize + font.lineSpacing)))
			};
		return ret;
	};
	if (!LineBreaker) {
		throw 'please set LineBreaker';
	}
	return sizer;
};
